export default "__VITE_ASSET__CPbOEkN1__"